import { BaseCell } from "@similarweb/pro-logic-components";

import { BenchmarkMetricName } from "app/pages/benchmark-tracker/types/api.types";
import { OtherCompetitorsCell } from "app/pages/benchmark-tracker/components/common/OtherCompetitorsCell";

import WebsiteWithFaviconCell from "../../../Share/WebsiteWithFaviconCell/WebsiteWithFaviconCell";
import type { BenchmarkColumnSchema } from "../TableView/config";
import { customPercentageCellRender } from "../TableView/config";
import type { ColumnNames } from "../TableView/type";

type TableColumnsSchema = {
    names: ColumnNames[];
    overwrite: Record<string, BenchmarkColumnSchema>;
};

export const getTableColumns = ({
    onOtherCompetitorsClick,
}: {
    onOtherCompetitorsClick: () => void;
}): TableColumnsSchema => ({
    names: ["domain", "audienceReach", "mom", "trends"],
    overwrite: {
        domain: {
            width: 320,
            render: (value: string, row: Record<PropertyKey, any>) =>
                row?.isOtherCompetitors ? (
                    <OtherCompetitorsCell onClick={onOtherCompetitorsClick}>{row?.domain}</OtherCompetitorsCell>
                ) : (
                    <WebsiteWithFaviconCell
                        value={value}
                        row={row}
                        tooltipClassName="websiteTooltipModalView"
                        showTooltip={false}
                        metricName={BenchmarkMetricName.audienceReach}
                    />
                ),
        },
        audienceReach: {
            width: 145,
            render: (value: number, row: Record<PropertyKey, any>) =>
                row?.isOtherCompetitors ? <BaseCell>-</BaseCell> : customPercentageCellRender(value, row),
        },
        mom: {
            width: 90,
            dataIndex: "mom",
        },
        trends: {
            width: 145,
        },
    },
});
